import { enableProdMode, StaticProvider } from '@angular/core';

import { environment } from '../environments/environment';
import { type PersistStateParams, type AkitaConfig, type PersistState } from '@datorama/akita';
import { localSettingsStoreName } from '@shared/store/localSettings/local-settings-store';
import * as localForage from 'localforage';

export const initFn = (
	akitaConfig: (config: AkitaConfig) => void,
	persistState: (params?: Partial<PersistStateParams>) => PersistState
): {
	providers: StaticProvider[];
} => {
	if (environment.production) {
		enableProdMode();
	}

	akitaConfig({ resettable: true });

	// MIDC clear storage on logout without caring about us. In 21b it will be changed to use user settings
	localForage.config({
		driver: localForage.INDEXEDDB,
		name: 'Akita',
		version: 1.0,
		storeName: 'akita-storage'
	});

	const localSettingsPersistStorage = persistState({
		include: [localSettingsStoreName],
		key: 'localSettingsStore',
		persistOnDestroy: true,
		storage: localForage
	});

	const providers = [{ provide: 'persistStorage', useValue: localSettingsPersistStorage }];

	return {
		providers
	};
};
